import { useEffect, useState } from 'react';
import axios from 'axios';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import './HinduFest.scss';

const monthImages = {
  January: 'https://cdnb.artstation.com/p/assets/images/images/053/207/067/large/nikhil-mishra-hanuman-8-3-wm.jpg?1661687366',
  February: 'https://5.imimg.com/data5/SELLER/Default/2024/7/433447086/QF/FI/JB/223567909/radha-krishna-mural-paintings.jpeg',
  March: 'https://5.imimg.com/data5/SELLER/Default/2024/7/433447086/QF/FI/JB/223567909/radha-krishna-mural-paintings.jpeg',
  April: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5mHXcVLMHUuv9NsQlTM9-9ipHYzE_Jtf6Ww&s',
  May: 'https://cdnb.artstation.com/p/assets/images/images/053/207/067/large/nikhil-mishra-hanuman-8-3-wm.jpg?1661687366',
  June: 'https://5.imimg.com/data5/SELLER/Default/2024/7/433447086/QF/FI/JB/223567909/radha-krishna-mural-paintings.jpeg',
  July: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5mHXcVLMHUuv9NsQlTM9-9ipHYzE_Jtf6Ww&s',
  August: 'https://cdnb.artstation.com/p/assets/images/images/053/207/067/large/nikhil-mishra-hanuman-8-3-wm.jpg?1661687366',
  September: 'https://5.imimg.com/data5/SELLER/Default/2024/7/433447086/QF/FI/JB/223567909/radha-krishna-mural-paintings.jpeg',
  October: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5mHXcVLMHUuv9NsQlTM9-9ipHYzE_Jtf6Ww&s',
  November: 'https://cdnb.artstation.com/p/assets/images/images/053/207/067/large/nikhil-mishra-hanuman-8-3-wm.jpg?1661687366',
  December: 'https://5.imimg.com/data5/SELLER/Default/2024/7/433447086/QF/FI/JB/223567909/radha-krishna-mural-paintings.jpeg',
};

const HinduFest = () => {
  const [festivalsData, setFestivalsData] = useState({});
  const [expanded, setExpanded] = useState({});
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const fetchFestivals = async () => {
      try {
        const { data } = await axios.get(
          `https://core-c343.onrender.com/api/hindu-festival?year=${selectedYear}`
        );

        if (data && data.months) {
          setFestivalsData(data.months);
          setExpanded({});
        } else {
          console.error('API error: Success false');
        }
      } catch (err) {
        console.error('Error fetching festivals:', err);
      }
    };

    fetchFestivals();
  }, [selectedYear]);

  const toggleExpand = (month) => {
    setExpanded((prev) => ({
      ...prev,
      [month]: !prev[month],
    }));
  };

  return (
    <div className="HinduFest-container">
      <InnerNav />
      <div className="hindufest-content">
        <Zodiac />

        <div className="hindufest-lists">
          <div className="year-selectorr">
            <label htmlFor="year-select">Select Year: </label>
            <input
              id="year-select"
              type="number"
              min="1900"
              max="2100"
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
            />
          </div>

          {Object.entries(festivalsData).map(([month, festivals]) => {
            const isExpanded = expanded[month];
            const visibleFestivals = isExpanded ? festivals : festivals.slice(0, 4);
            const img = monthImages[month] || '';

            return (
              <div className="hindufest-items" key={month}>
                <div className="header">
                  <h4>{month} Month Hindu Festivals</h4>
                </div>

                <div className="fest-grid">
                  {visibleFestivals.map((fest, i) => (
                    <div className="hindufest-card" key={i}>
                      <img src={img} alt={fest.name} />
                      <div className="name">{fest.name}</div>
                      <div className="name">{fest.date}</div>
                    </div>
                  ))}
                </div>

                {festivals.length > 4 && (
                  <div className="section-more-button">
                    <button onClick={() => toggleExpand(month)}>
                      {isExpanded ? `...less ${month} Festivals` : `...more ${month} Festivals`}
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default HinduFest;
